export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/apartment.9eb00cb.svg";